import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-exportleads',
  templateUrl: './exportleads.component.html',
  styleUrls: ['./exportleads.component.css']
})
export class ExportleadsComponent implements OnInit {

  public displayedColumns: any;
  public expotype: number = 1;
  public camptype: number = 0;

  dialerlist: any[]
  cD: number = -1
  personalClColumns: any[] = [];
  chkAPer: boolean=false;
  clientClColumns: any[]= [];
  chkACli: boolean;
  spouseClColumns: any[] = [];
  chkASps: boolean;
  lifeClColumns: any[];
  chkALf: boolean;
  DCdata: any;
  svLeadColumns: any = [];
  etype: number = 0;
  dialerColumns: any = []
  isChk: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<ExportleadsComponent>) {
    console.log(data);
  }

  ngOnInit() {
    if (this.data) {
      this.camptype = this.data.camptype;
    }

    // @dialer mapping
    if (sessionStorage.getItem("allcampaign")) {
      this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))
    }
    let e = {value :1}
    this.eType(e)
  }

  onExport() {
    if (this.expotype == 2) {
      if (this.cD > 0) {
        this.dialogRef.close({
          sLeadsColumns: this.svLeadColumns,
          etype: this.etype,
          id_dialer: this.cD,
          dialer_columns: this.dialerColumns,
          expotype: this.expotype
        })
      } else {
        alert("Kindly select atleast 1 dialer to restore the leads.")
        return false
      }
    } else {
      this.dialogRef.close({
        id_dialer: this.cD,
        expotype: this.expotype
      })
    }
  }

  onSelectionChange(type: number) {
    this.expotype = type;
    console.log("Type ::" + type);
  }

  Close() {
    this.dialogRef.close();
    console.log("close");
  }



   // to get personal data of leads
   personalCl: any = [
    {
      key: "first_name",
      value: "First Name"
    },
    {
      key: "last_name",
      value: "Last Name"
    },
    {
      key: "cell_phone",
      value: "Cell Phone"
    },
    {
      key: "phone",
      value: "Phone"
    },
    {
      key: "work_phone",
      value: "Work Phone"
    },
    {
      key: "street_address_1",
      value: "Street Address1"
    },
    {
      key: "street_address_2",
      value: "Street Address2"
    },
    {
      key: "city",
      value: "City"
    },
    {
      key: "state",
      value: "State"
    },
    {
      key: "zip",
      value: "Zip"
    },
    {
      key: "county",
      value: "County"
    }
  ]

  // to get client data of leads
  clientCl: any = [
    {
      key: "birth_date",
      value: "Birth Date"
    },
    {
      key: "age",
      value: "Age"
    },
    {
      key: "height",
      value: "Height"
    },
    {
      key: "weight",
      value: "Weight"
    },
    {
      key: "occupation",
      value: "Occupation"
    }
  ]

  // to get spouse data of leads
  spouseCl: any = [
    {
      key: "spouse_full_name",
      value: "Spouse Full Name"
    },
    {
      key: "spouse_age",
      value: "Spouse Age"
    },
    {
      key: "spouse_birth_date",
      value: "Spouse Birth Date"
    },
    {
      key: "spouse_height",
      value: "Spouse Height"
    },
    {
      key: "spouse_weight",
      value: "Spouse Weight"
    },
    {
      key: "spouse_occupation",
      value: "Spouse Occupation"
    }
  ]

  chkAll(e: any, type: number): void {
    console.log("status:", e.srcElement.checked)
    let eChecked: any = e.srcElement.checked

    // @for personal details
    if (type == 1) {
      this.personalClColumns = []
      if (eChecked) {
        this.chkAPer = true
        for (let x of this.personalCl) {
          this.personalClColumns.push(x.key)
        }
      } else {
        this.chkAPer = false
      }
      console.log("this.sLeadsColumns::", this.personalClColumns)
      console.log(JSON.stringify(this.personalClColumns))
    }

    // @for client details
    if (type == 2) {
      this.clientClColumns = []
      if (eChecked) {
        this.chkACli = true
        for (let x of this.clientCl) {
          this.clientClColumns.push(x.key)
        }
      } else {
        this.chkACli = false
      }
      console.log("this.sLeadsColumns::", this.clientClColumns)
      console.log(JSON.stringify(this.clientClColumns))
    }

    // @for spouse details
    if (type == 3) {
      this.spouseClColumns = []
      if (eChecked) {
        this.chkASps = true
        for (let x of this.spouseCl) {
          this.spouseClColumns.push(x.key)
        }
      } else {
        this.chkASps = false
      }
      console.log("this.sLeadsColumns::", this.spouseClColumns)
      console.log(JSON.stringify(this.spouseClColumns))
    }

    // @for life dialer details
    if (type == 4) {
      this.lifeClColumns = []
      if (eChecked) {
        this.chkALf = true
        for (let x of this.DCdata) {
          this.lifeClColumns.push(x.key)
        }
      } else {
        this.chkALf = false
      }
      console.log("this.sLeadsColumns::", this.lifeClColumns)
      console.log(JSON.stringify(this.lifeClColumns))
    }
  }

  getField(e: any, type: number) {
    console.log(e)
    console.log("status:", e.srcElement.checked)
    console.log("value:", e.target.value)
    let eChecked: any = e.srcElement.checked
    let value: any = e.target.value

    // @for personal details
    if (type == 1) {
      // this.personalClColumns=[]
      if (eChecked) {
        this.personalClColumns.push(value);
      } else {
        let crindex = this.personalClColumns.findIndex(function (ele, i) {
          return ele === value
        });
        this.personalClColumns.splice(crindex, 1);
      }
      console.log("this.personalClColumns::", this.personalClColumns)
      console.log(JSON.stringify(this.personalClColumns))
    }

    // @for client details
    if (type == 2) {
      // this.clientClColumns=[]
      if (eChecked) {
        this.clientClColumns.push(value);
      } else {
        let crindex = this.clientClColumns.findIndex(function (ele, i) {
          return ele === value
        });
        this.clientClColumns.splice(crindex, 1);
      }
      console.log("this.clientClColumns::", this.clientClColumns)
      console.log(JSON.stringify(this.clientClColumns))
    }

    // @for spouse details
    if (type == 3) {
      // this.spouseClColumns=[]
      if (eChecked) {
        this.spouseClColumns.push(value);
      } else {
        let crindex = this.spouseClColumns.findIndex(function (ele, i) {
          return ele === value
        });
        this.spouseClColumns.splice(crindex, 1);
      }
      console.log("this.spouseClColumns::", this.spouseClColumns)
      console.log(JSON.stringify(this.spouseClColumns))
    }

    // @for life dialer
    if (type == 4) {
      this.lifeClColumns=[]
      if (eChecked) {
        this.lifeClColumns.push(value);
      } else {
        let crindex = this.lifeClColumns.findIndex(function (ele, i) {
          return ele === value
        });
        this.lifeClColumns.splice(crindex, 1);
      }
      console.log("this.lifeClColumns::", this.lifeClColumns)
      console.log(JSON.stringify(this.lifeClColumns))
    }
  }

  export(): void {
    if (this.etype) {
      // @personal detail iteration
      for (let x of this.personalCl) {
        if (this.personalClColumns.includes(x.key)) {
          this.svLeadColumns.push(x)
        }
      }

      // @client detail iteration
    if(this.clientClColumns!=undefined)
    {
      for (let x of this.clientCl) {
        if (this.clientClColumns.includes(x.key)) {
          this.svLeadColumns.push(x)
        }
      }
    }
      

      // @spouse detail iteration

      if(this.spouseClColumns!=undefined)
      {
        for (let x of this.spouseCl) {
          if (this.spouseClColumns.includes(x.key)) {
            this.svLeadColumns.push(x)
          }
        }
      }
      

      // @life dialer iteration
      // for (let x of this.DCdata) {
      //   if (this.lifeClColumns.includes(x.key)) {
      //     this.dialerColumns.push(x)
      //   }
      // }
      console.log(this.svLeadColumns)
      this.onExport()
    } else {
      alert("Please select an export type")
    }
  }

 /*  Close() {
    this.dialogRef.close({
      sLeadsColumns: this.svLeadColumns,
      etype: this.etype,
      id_dialer: this.cD,
      dialer_columns: this.dialerColumns,
      expotype: this.expotype
    })
  } */

  eType(e: any): void {
    console.log("value:", e.value)
    this.etype = e.value
  }

  loadDT(e: any): void {
    console.log("e::", e)
    let id_dialer = e.value
  }
}
